<lib-taxonomy-container
  *ngIf="clientId > 0 && brandId > 0"
  [clientId]="clientId"
  [brandId]="brandId"
  [userType]="userType"></lib-taxonomy-container>
